/** Dashboard callables that validate clinic settings on the server (section 9.2, 13). */
import { z } from "zod";
/** `setDomains`: the clinic's website domains, checked against the licensed site count. */
export const setDomainsRequestSchema = z.object({
    domains: z.array(z.string().min(3).max(253)).max(20),
});
/** `setSiteCount`: changes the number of websites on the yearly subscription (one licence per site). */
export const setSiteCountRequestSchema = z.object({
    sites: z.number().int().min(1).max(50),
});
/** `savePushSubscription`: registers this browser for web push (one per device). */
export const savePushSubscriptionRequestSchema = z.object({
    subscription: z.object({
        endpoint: z.string().url().max(2048),
        keys: z.object({ p256dh: z.string().min(1).max(256), auth: z.string().min(1).max(256) }),
    }),
    userAgent: z.string().max(300).optional(),
});
/** `removePushSubscription`: forgets this browser's subscription. */
export const removePushSubscriptionRequestSchema = z.object({
    endpoint: z.string().url().max(2048),
});
//# sourceMappingURL=clinic.js.map